module.exports = __webpack_public_path__ + "images/warning-red82bd598cdee4639e6ac76bf563b2dcfb.svg";